import { ApiVersion } from "../const";


export const getLastData = (token: string, id: number, type: number) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({ id: id, type: type })

    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}getLastData`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })

}

export const getGraphData = (token: string, iniDate: string, finDate: string, data: string ) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({ iniDate: iniDate, finDate: finDate, data: data })
    };
    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}getElectricalDataChar`, requestOptions)
        .then(response =>{
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}

export const getQualityDataChar = (token: string, id: number, iniDate: string, finDate: string, type: number) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({ id: id, iniDate: iniDate, finDate: finDate, type: type })
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}getQualityDataChar`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}

export const getAmbientalDataChar = (token: string, id: number, iniDate: string, finDate: string, type: number) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({ id: id, iniDate: iniDate, finDate: finDate, type: type })
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}getAmbientalDataChar`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}


export const getAllDataByDates = (token: string, id: number, iniDate: string, finDate: string, type: number) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({ id: id, iniDate: iniDate, finDate: finDate, type: type })
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}getAllDataByDates`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}